// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3351d163","633":"825bfd99"}[chunkId] + ".chunk.js";
};